import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { constant } from "../app.constants";
const reqOptns = {
    headers: new HttpHeaders().set("isLoadNotReq", "true")
}
@Injectable({
    providedIn: "root"
})
export class BussineceIntelligenceService {

    constructor(private _http: HttpClient) { }

    getPatientBI(data) {
        return this._http.post(constant.POST_GET_Patient_BI, data, reqOptns);
    }
    getPrescriberBI(data) {
        return this._http.post(constant.POST_Prescriber_BI, data, reqOptns);
    }
    getInsuranceBI(data) {
        return this._http.post(constant.POST_Insurance_BI, data, reqOptns);
    }

    getMyPatientData(data) {
        return this._http.post(constant.POST_GET_My_Patients, data, reqOptns);
    }

    getDrugData(data) {
        return this._http.post(constant.POST_Drug_BI, data, reqOptns);
    }

  getMypatientAmount(data) {
      return this._http.post<any>(constant.POST_GET_My_Patinets_Amount, data);
  }
}
